<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->

<template>
	<div class="qwoach-form my-5 error-no-expand">
		<div class="mb-4">
			<StepTitle style="margin-bottom: 40px;">
				This wizard will guide you through the steps of setting up your coaching program.
			</StepTitle>

			<div class="mb-4">Coaching program is the centralized place to keep track of your client's progress.</div>

			<div class="mb-4">Coaching program allows you to share your coaching materials and files, to keep track of your private or shared notes, accept payments from your clients, keep track of coaching sessions, manage your agreements and signatures and more.</div>

			<div class="mb-4">You'll be able to reuse your coaching program multiple times for different clients and to further adjust it individually for each client.</div>

			<div class="mb-4">After you setup your coaching program, you'll be able to invite clients to join the program. At that point your clients will get access to the program's materials through their personal secure portal.</div>

			<div class="text-center pt-4">
				<qw-button type="primary"
						   class="text-center"
						   style="width: 200px;"
						   @click="nextStep">
					Get started
				</qw-button>
			</div>




		</div>
	</div>
</template>

<script>
import BaseWizardStep from "@/core/components/Wizard/BaseWizardStep.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import CoachingProgram, {ProgramCategoryEnum, ProgramTypeEnum} from "@shared/Program/CoachingProgram";
import {delay} from "@/utils/helpers";
import StepTitle from "@/core/components/Wizard/StepTitle.vue";

export default {
	name: "IntroStep",
	components: {StepTitle},
	extends: BaseWizardStep,

	data() {
		return {

		}
	},

	methods:{
		// async validateForm(){
		// 	return true
		// }

		stepId(){
			return "intro_step"
		},

		isStepRequired(){
			return true
		},

		getTitle(){
			return ""
		},

		hideActionButtons(){
			return true
		},



	}
}
</script>

<style lang="scss">

</style>
